/**
 * Delete child from parent or remove whole parent recursively
 * @param {string} removedNodeIdx Deleted node id
 * @param {Map<string, TreeItem<T>>} treeItemsMap Target map of tree items
 * @param {Array<[string, TreeItem<T>]>} treeItemsEntries Original tree items
 * @return {Array<ITreeProps<T>>} Filtered trees
 */
const _deleteParentChildOrNode = (removedNodeIdx, treeItemsMap, treeItemsEntries) => {
    // 1. Find parent node of leaf node
    const parent = treeItemsEntries.find((entry) => entry[1].children?.some((c) => c === removedNodeIdx));
    if (parent) {
        // 2. Delete child from parent node or delete whole parent node
        const parentIdx = parent[0];
        const parentMap = treeItemsMap.get(parentIdx);
        if (parentMap) {
            const children = parentMap.children?.filter((c) => c !== removedNodeIdx);
            if ((children ?? []).length === 0) {
                // 2.1. Delete parent node
                treeItemsMap.delete(parentIdx);
                _deleteParentChildOrNode(parentIdx, treeItemsMap, treeItemsEntries);
            }
            else {
                // 2.2. Delete child from parent children
                treeItemsMap.set(parentIdx, { ...parentMap, children });
            }
        }
    }
};
/**
 * Filter nodes of trees
 * @param {Array<ITreeProps<T>>} trees List of trees
 * @param {string} query Filter query
 * @return {Array<ITreeProps<T>>} List of filtered trees
 */
export const filterTrees = (trees, query) => {
    const queryLowerCase = query.toLowerCase();
    const resultTrees = trees.map((tree) => {
        // 1. Create a map
        const treeItemsEntries = Object.entries(tree.treeItems);
        const indexes = Object.keys(tree.treeItems);
        const treeItemsMap = new Map(treeItemsEntries);
        // 2. Iterate by indexes
        indexes.forEach((idx) => {
            const leaf = treeItemsMap.get(idx);
            if (leaf && !leaf.isFolder && !leaf.data.name?.toLowerCase().includes(queryLowerCase)) {
                // 2.1. Delete leaf node
                treeItemsMap.delete(idx);
                // 2.2. Find parent node of leaf node
                _deleteParentChildOrNode(idx, treeItemsMap, treeItemsEntries);
            }
        });
        return {
            ...tree,
            treeItems: Object.fromEntries(treeItemsMap)
        };
    });
    // 3. Return non-empty trees
    return resultTrees.filter((tree) => Object.keys(tree.treeItems).length > 0);
};
//# sourceMappingURL=TreeList.helpers.js.map